import { CSSProperties, ReactNode } from "react";
import { TranslationService } from "../../../../../services/TranslationService";

const skeletonPulse: CSSProperties = {
  background: "linear-gradient(90deg, #e9ecef 25%, #f3f4f6 50%, #e9ecef 75%)",
  backgroundSize: "200% 100%",
  animation: "aiBillingSkeleton 1.4s ease-in-out infinite",
  borderRadius: "6px"
};

const AIBillingKpiCard = ({
  label,
  value,
  subtitle,
  loading,
  error,
  emphasis
}: {
  label: string;
  value: ReactNode;
  subtitle?: string;
  loading: boolean;
  error: boolean;
  emphasis?: boolean;
}) => {
  const { translate } = TranslationService;
  return (
    <div className="card h-100" style={{ borderRadius: 10, minWidth: 0 }}>
      <style>{`@keyframes aiBillingSkeleton{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
      <div
        className="card-body d-flex flex-column justify-content-center"
        style={{ padding: "14px 16px" }}
      >
        <span style={{ fontSize: "0.75rem", color: "#666" }}>{label}</span>
        {loading && (
          <div
            style={{ ...skeletonPulse, width: 120, height: 28, marginTop: 6 }}
          />
        )}
        {!loading && error && (
          <span className="text-danger small" style={{ marginTop: 6 }}>
            {translate.ErrorLoadingData}
          </span>
        )}
        {!loading && !error && (
          <span
            style={{
              fontSize: emphasis ? "2rem" : "1.75rem",
              fontWeight: 650,
              lineHeight: 1.1,
              letterSpacing: "-0.3px",
              marginTop: 6
            }}
          >
            {value}
          </span>
        )}
        {!loading && !error && subtitle && (
          <span style={{ fontSize: "0.75rem", color: "#888", marginTop: 6 }}>
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

export default AIBillingKpiCard;
